/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as AbsenceActions from '@absences/store/absences.actions';
import { AbsencesState, initialState } from '@absences/store/absences.state';

export function absencesReducer(state = initialState, action: AbsenceActions.AbsencesActions): AbsencesState {
  switch (action.type) {
    case AbsenceActions.LOAD_ABSENCES:
      return {
        ...state,
        isActionPending: true,
        owner: action.owner
      };
    case AbsenceActions.PERSIST_ABSENCE:
      return {
        ...state,
        isActionPending: true
      };
    case AbsenceActions.LOAD_ABSENCES_SUCCESS:
      return {
        ...state,
        isActionPending: false,
        absences: action.absences
      };
    case AbsenceActions.LOAD_ABSENCES_FAILURE:
    case AbsenceActions.PERSIST_ABSENCE_FAILURE:
    case AbsenceActions.PERSIST_ABSENCE_SUCCESS:
      return {
        ...state,
        isActionPending: false
      };
    case AbsenceActions.INIT:
    case AbsenceActions.LOAD_ABSENCE_CLASSES_SUCCESS:
      return {
        ...state,
        absenceClasses: action.absenceClasses
      };
    case AbsenceActions.LOAD_SELECTABLE_ABSENCE_CLASSES_SUCCESS:
      return {
        ...state,
        selectableAbsenceClasses: action.absenceClasses
      };
    case AbsenceActions.EDIT_ABSENCE:
      return {
        ...state,
        currentAbsence: action.absence
      };
    default:
      return state;
  }
}
